<template>
  <div>
    <div class="content-page-banner">
      <div class="banner-content">
        <h1>Thank you for contacting us</h1>
        <div class="underline"></div>
        <p>Your form has been submitted. We will get back to you shortly.</p>
      </div>
    </div>

    <div class="page-section">
      <p class="no-bottom-margin">If you would like to talk to our team of experts quickly, they are available to chat online:</p>
      <OpeningHours openingHoursOnly />
    </div>

    <table class="review-table page section">
      <tr>
        <th>What are you contacting us about?</th>
        <td>{{ requestType }}</td>
      </tr>
      <template v-if="isPublicSite">
        <tr v-if="firstName !== ''">
          <th>First name</th>
          <td>{{ firstName }}</td>
        </tr>
        <tr v-if="lastName !== ''">
          <th>Last name</th>
          <td>{{ lastName }}</td>
        </tr>
      </template>
      <tr v-if="contactMethod">
        <th>How would you like us to contact you?</th>
        <td>{{ contactMethod }}</td>
      </tr>
      <tr v-if="isContactByEmail && email !== ''">
        <th>Email address</th>
        <td>{{ email }}</td>
      </tr>
      <tr v-if="!isContactByEmail && phoneNumber !== ''">
        <th>Phone number</th>
        <td>{{ phoneNumber }}</td>
      </tr>
      <tr>
        <th>What would you like to say?</th>
        <td>{{ requestmessage }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { fetchSessionObject, clearSessionObject } from '@/utils';
import { STORAGE_KEYS, toSentenceCase } from '@general/js/utils';
import OpeningHours from '@general/js/components/LiveChat.vue';
import { PageURLs } from '@general/js/enums/PageURLsEnum';

export default {
  name: 'contactUsConfirmation',

  props: {
    isPublicSite: {
      type: Boolean,
      default: true,
    },

    /**
     * this is only required if isPublicSite is false
     */
    refData: {
      type: Object,
    },
  },

  components: {
    OpeningHours,
  },

  data() {
    return {
      requestType: '',
      firstName: '',
      lastName: '',
      contactMethod: '',
      email: '',
      phoneNumber: '',
      requestmessage: '',
    };
  },

  beforeMount() {
    if (this.isPublicSite) {
      this.isFromPublicSite();
    } else {
      this.isFromMemberPortal();
    }
  },

  computed: {
    isContactByEmail() {
      const data = !this.isPublicSite ? this.refData : this;
      return data?.contactMethod.toLowerCase() === 'email';
    },
  },

  methods: {
    isFromPublicSite() {
      // Update data from session storage. if data is not available, redirect to public site contact us page.
      const formResponse = fetchSessionObject(STORAGE_KEYS.CONTACT_US.FORM_RESPONSE);
      if (formResponse) {
        this.requestType = formResponse.requestTypeDisplayText;
        this.firstName = formResponse.firstName;
        this.lastName = formResponse.lastName;
        this.contactMethod = toSentenceCase(formResponse.contactMethod);
        this.email = formResponse.email;
        this.phoneNumber = formResponse.phoneNumber;
        this.requestmessage = formResponse.requestmessage;

        // Clear session storage
        clearSessionObject(STORAGE_KEYS.CONTACT_US.FORM_RESPONSE);
      } else {
        document.location.href = PageURLs.CONTACT_US;
      }
    },

    isFromMemberPortal() {
      if (this.refData !== undefined) {
        this.requestType = this.refData.requestTypeDisplayText;
        this.firstName = this.refData.firstName;
        this.lastName = this.refData.lastName;
        this.contactMethod = toSentenceCase(this.refData.contactMethod);
        this.email = this.refData.email;
        this.phoneNumber = this.refData.phoneNumber;
        this.requestmessage = this.refData.requestmessage;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.no-bottom-margin {
  margin-bottom: 0;
}

.review-table {
  border: 1px solid $GREY_300;
  border-left: none;
  border-right: none;
  padding: calc(#{spacer(2.5)} - 7.5px) 0;
  margin: spacer(3) 0 spacer(10);
  width: 100%;

  th,
  td {
    border-bottom: 0;
    padding: 7.5px 0;
    vertical-align: baseline;
  }

  th {
    max-width: 245px;
    border-right: spacer(2) solid transparent;
  }

  @include mobile {
    tr {
      display: grid;
      grid-template-columns: 1fr;

      th {
        max-width: unset;
        border-right: 0;
      }
    }
  }
}

.page-section {
  margin: 56px 0;

  @include mobile {
    margin: 24px 0;
  }
}
</style>
